// ../core/dist/index.mjs
function tryOr(fn, or) {
  try {
    return fn();
  } catch (e) {
    return or;
  }
}

// src/maybe.ts
function isNone(m) {
  return m == null;
}
function isSome(m) {
  return m != null;
}
function maybe(inner) {
  if (inner == null)
    return null;
  else
    return new Maybe(inner);
}
var Maybe = class {
  constructor(inner) {
    this.inner = inner;
  }
  let(mapping) {
    return maybe(mapping(this.inner));
  }
  takeIf(predicate) {
    if (predicate(this.inner))
      return this.inner;
    else
      return null;
  }
  takeUnless(predicate) {
    if (predicate(this.inner))
      return null;
    else
      return this.inner;
  }
  if(predicate) {
    if (predicate(this.inner))
      return this;
    else
      return null;
  }
  unless(predicate) {
    if (predicate(this.inner))
      return null;
    else
      return this;
  }
  try(mapping) {
    return tryOr(() => this.let(mapping), null);
  }
  tryTake(mapping) {
    return this.try(mapping)?.take() ?? null;
  }
  also(fn) {
    fn(this.inner);
    return this;
  }
  take(mapping) {
    return typeof mapping == "function" ? mapping(this.inner) : this.inner;
  }
};
export {
  isNone,
  isSome,
  maybe
};
